export const siteInfo = {
  name: "瓜田日报",
  shortName: "瓜田",
  tagline: "爆料吃瓜 · 每日合集",
  intro:
    "瓜田日报把散落全网的娱乐话题整理成一份清爽的每日合集，热门盘点、事件汇总、明星动态一次看全，让吃瓜群众不用再翻遍全网。",
  email: "contact@gua-tian.example.com",
  workTime: "每天 09:00 — 23:00 更新合集",
  feedbackTime: "收到留言后 1 个工作日内回复",
  since: "2024",
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "每日合集", path: "/daily" },
  { label: "热门盘点", path: "/ranking" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const sectionAnchors = [
  { label: "今日焦点", id: "focus" },
  { label: "今日热榜", id: "hot" },
  { label: "每日合集", id: "daily" },
  { label: "主题分类", id: "topics" },
  { label: "本周盘点", id: "weekly" },
  { label: "常见问题", id: "faq" },
];

export const footerLinks = [
  {
    title: "站内导航",
    links: [
      { label: "首页", path: "/" },
      { label: "每日合集", path: "/daily" },
      { label: "热门盘点", path: "/ranking" },
      { label: "关于我们", path: "/about" },
    ],
  },
  {
    title: "热门分类",
    links: [
      { label: "明星恋情", path: "/daily?category=romance" },
      { label: "作品动态", path: "/daily?category=works" },
      { label: "综艺名场面", path: "/daily?category=variety" },
      { label: "时尚造型", path: "/daily?category=fashion" },
    ],
  },
  {
    title: "帮助与支持",
    links: [
      { label: "常见问题", path: "/about#faq" },
      { label: "内容原则", path: "/about#principle" },
      { label: "联系我们", path: "/contact" },
      { label: "用户口碑", path: "/about#voice" },
    ],
  },
];

export const testimonialList = [
  {
    name: "阿柚",
    role: "三年老吃瓜群众",
    content:
      "以前要刷七八个平台才拼得出事件全貌，现在每天先看瓜田日报的合集，十分钟不到就能把当天的瓜理清楚。",
  },
  {
    name: "小满",
    role: "通勤党",
    content:
      "地铁上刷一篇每日合集刚刚好，速览要点写得很清楚，不会看到一半还不知道发生了啥。",
  },
  {
    name: "老陈",
    role: "资深娱乐版编辑",
    content:
      "他们的时间线梳理和事件汇总做得挺克制，不夸大也不带节奏，我们选题时也会拿来对照。",
  },
  {
    name: "林女士",
    role: "家庭用户",
    content:
      "最喜欢热门盘点，一周热点一次看完，不用被各种零碎推送打断，省心很多。",
  },
];